import { Check } from "lucide-react";

export default function StepIndicator({ currentStep }) {
  const totalSteps = 5;

  return (
    <div className="flex items-center justify-center my-8">
      {[...Array(totalSteps)].map((_, index) => (
        <div key={index} className="flex items-center">
          <div
            className={`
              w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300
              ${currentStep > index + 1 ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-500"}
              ${currentStep === index + 1 ? "bg-blue-500 text-white transform scale-110" : ""}
            `}
          >
            {currentStep > index + 1 ? (
              <Check size={16} />
            ) : (
              <span className="text-sm font-semibold">{index + 1}</span>
            )}
          </div>
          {index < totalSteps - 1 && (
            <div
              className={`
                h-1 transition-all duration-300
                ${currentStep > index + 1 ? "bg-blue-600 w-12" : "bg-gray-200 w-8"}
              `}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
}